import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b3afffb8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 2,
  class: "flex-ter"
}

import { t } from '@/plugins/i18n'

import { productSkuEdit } from '@/apis/inShipping'
import { ElMessage } from 'element-plus'

export default /*#__PURE__*/_defineComponent({
  props: ['row', 'isLimit'],
  setup(__props) {

const props = __props


const saveOverseaProducSku = (row: any) => {
  const { overseaProducSku, shopProductSku } = row
  row.loading = true
  productSkuEdit({ overseaProducSku, shopProductSku }).then(() => {
    ElMessage.success(t('保存成功'))
  }).finally(() => {
    row.loading = false
    row.showOverseaProducSku = false
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!

  return (__props.row.overseaProducSku && !__props.row.showOverseaProducSku)
    ? (_openBlock(), _createBlock(_component_el_tooltip, {
        key: 0,
        effect: "light",
        placement: "top"
      }, {
        content: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(__props.row.overseaProducSku), 1)
        ]),
        default: _withCtx(() => [
          (__props.row.overseaProducSku && !__props.row.showOverseaProducSku)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: "show-one-line",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (__props.row.showOverseaProducSku = true))
              }, _toDisplayString(__props.row.overseaProducSku), 1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }))
    : (!__props.row.overseaProducSku && !__props.row.showOverseaProducSku)
      ? (_openBlock(), _createElementBlock("a", {
          key: 1,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (__props.row.showOverseaProducSku = true))
        }, _toDisplayString(_unref(t)('填写')), 1))
      : (__props.row.showOverseaProducSku)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_el_input, {
              modelValue: __props.row.overseaProducSku,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((__props.row.overseaProducSku) = $event)),
              size: "small"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_el_button, {
              style: {"margin-left":"4px"},
              loading: __props.row.loading,
              onClick: _cache[3] || (_cache[3] = ($event: any) => (saveOverseaProducSku(__props.row)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('保存')), 1)
              ]),
              _: 1
            }, 8, ["loading"])
          ]))
        : _createCommentVNode("", true)
}
}

})